<template>
  <quill-editor
    ref="detailEditor"
    v-model="content"
    :options="editorOption"
    @change="onChange"
  ></quill-editor>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import * as Quill from 'quill';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// 拖拽上传
import { ImageDrop } from 'quill-image-drop-module';
// 调整上传图片大小
import ImageResize from 'quill-image-resize-module';
// 粘贴图片上传
import { ImageExtend, container, QuillWatch } from 'quill-image-paste-module';
// 注册事件
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/ImageExtend', ImageExtend);

import { getToken } from '@/utils/auth';

export default {
  name: 'Edit',
  props: {
    value: String,
    placeholder: String
  },
  components: { quillEditor },
  data() {
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      editorOption: {},
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      content: ''
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal && newVal !== this.content) {
        this.content = newVal;
      } else if (!newVal) {
        this.content = '';
      }
    }
  },
  created() {
    this.content = this.value;
    this.editorOption = {
      placeholder: this.placeholder,
      uploadConfig: {
        action: this.uploadConfig.api,
        name: 'file',
        res: (respnse) => {
          return respnse.FileURL;
        }
      },
      modules: {
        // 调整图片大小
        imageResize: {
          displayStyles: {
            backgroundColor: 'black',
            border: 'none',
            color: 'white'
          },
          modules: ['Resize', 'DisplaySize', 'Toolbar']
        },
        // 截屏上传
        ImageExtend: {
          loading: true,
          name: 'file',
          change: (xhr, FormData) => {
            xhr.setRequestHeader('Authorization', getToken());
          },
          action: this.uploadConfig.api,
          response: (res) => {
            return res.FileURL;
          }
        },
        toolbar: {
          // 如果不上传图片到服务器，此处不必配置
          container: container, // container为工具栏，此次引入了全部工具栏，也可自行配置
          handlers: {
            image: function() {
              // 劫持原来的图片点击按钮事件

              QuillWatch.emit(this.quill.id);
            }
          }
        }
      }
    };
  },
  methods: {
    onChange() {
      this.$emit('input', this.content);
    }
  }
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Edit/index.vue